var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.scrollHandler),expression:"scrollHandler"}],staticClass:"video-box"},[(_vm.show)?_c((_vm.name + "Movie"),{tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }